import { PwaPushNotificationsUserSettings } from '../../services/pwa-push-notification/pwa-push-notifications-user-settings.type';
import { LoadStatus } from '../load-status';

/**
 * Feature key under which the PWA push-notification slice is registered in the root store.
 */
export const PWA_PUSH_NOTIFICATION_FEATURE_KEY = 'pwaPushNotification';

/**
 * The user's push-notification subscription choice, mirroring what
 * `PwaPushNotificationsLocalStorageService` persists in `localStorage`. `undefined` settings
 * means nothing has been saved yet (a first-time user). `status` tracks whether the settings
 * have been read from storage (see {@link LoadStatus}).
 */
export type PwaPushNotificationState = Readonly<{
    settings: PwaPushNotificationsUserSettings | undefined;
    status: LoadStatus;
}>;

export const initialPwaPushNotificationState: PwaPushNotificationState = {
    settings: undefined,
    status: LoadStatus.Idle,
};
